import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@/features/authorization/provider/useAuth';
import { PrivacyRoute } from '@/features/privacy/navigation/privacyRoute';
import { DeleteAccountScreen } from '@/features/privacy/screens/DeleteAccountScreen';
import { LegalScreen } from '@/features/privacy/screens/LegalScreen';
import { LegalTextScreen } from '@/features/privacy/screens/LegalTextScreen';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';

export const usePrivacyRouting = () => {
  const { t } = useTranslation(LocalizationNameSpace.PRIVACY, {
    keyPrefix: 'routes'
  });

  const { isAuthenticated } = useAuth();

  const privacyScreens = useMemo(() => {
    const screens = [
      <AppStack.Screen
        key={PrivacyRoute.LegalText}
        name={PrivacyRoute.LegalText}
        component={LegalTextScreen}
        options={({ route }) => ({
          header: () => (
            <NavigationBar
              title={route.params.name}
              type={NavBarType.MODAL_WITH_CLOSE}
            />
          ),
          headerShown: true,
          presentation: 'containedModal',
          animation: 'fade'
        })}
      />,
      <AppStack.Screen
        key={PrivacyRoute.Legal}
        name={PrivacyRoute.Legal}
        component={LegalScreen}
        options={() => ({
          header: () => (
            <NavigationBar
              title={t(PrivacyRoute.Legal)}
              centerTitle={isAuthenticated}
              type={
                isAuthenticated
                  ? NavBarType.DEFAULT
                  : NavBarType.MODAL_WITH_CLOSE
              }
            />
          ),
          headerShown: true,
          title: t(PrivacyRoute.Legal)
        })}
      />
    ];
    if (isAuthenticated) {
      screens.push(
        <AppStack.Screen
          key={PrivacyRoute.DeleteAccount}
          name={PrivacyRoute.DeleteAccount}
          component={DeleteAccountScreen}
          options={() => ({
            title: t(PrivacyRoute.DeleteAccount)
          })}
        />
      );
    }

    return screens;
  }, [isAuthenticated, t]);

  return { privacyScreens };
};
